import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-[720px] mx-auto px-6 lg:px-12 py-24" data-testid="payment-cancel-page">
      <div className="surface-card p-10 text-center">
        <XCircle size={72} className="mx-auto text-[var(--ff-text-dim)] mb-4" />
        <h1 className="font-display text-4xl mb-3">CHECKOUT CANCELED</h1>
        <p className="text-[var(--ff-text-dim)] font-mono-ui text-sm mb-6">
          No charge was made. You can pick up where you left off any time.
        </p>
        <div className="flex justify-center gap-3">
          <Link to="/shows" className="btn-primary" data-testid="payment-cancel-shows">Browse Shows</Link>
          <Link to="/" className="btn-ghost" data-testid="payment-cancel-home">Back Home</Link>
        </div>
      </div>
    </div>
  );
}
